/// <summary>
/// Auth : 정지효
/// Date : 2023/05/19
/// Desc : AI 시스템 관리자페이지
/// </summary>

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import {
  Column,
  DataGrid,
  FilterRow,
  HeaderFilter,
  GroupPanel,
  Scrolling,
  Editing,
  Grouping,
  Lookup,
  MasterDetail,
  Summary,
  RangeRule,
  RequiredRule,
  StringLengthRule,
  GroupItem,
  TotalItem,
  ValueFormat,
} from 'devextreme-react/data-grid';
import { createStore } from 'devextreme-aspnet-data/js/dx.aspnet.data';
import DateBox from 'devextreme-react/date-box';
import TextBox from 'devextreme-react/text-box';
import { NumberBox } from 'devextreme-react/number-box';
import { Button } from 'devextreme-react/button'; import ResponsiveBox, {
    Row,
    Col,
    Item,
    Location,
} from 'devextreme-react/responsive-box';
import Box from 'devextreme-react/box';
import './Login.css'
import { Cookies } from 'react-cookie';
import RecogResultDatagrid from './RecogResultDatagrid.js'
import { SelectBox } from 'devextreme-react';
import config from './Config.js';


export default function App() {

    const navigate = useNavigate();

    const cookies = new Cookies();

    const authCheck = () => {
        const aspNetCookie = cookies.get(".AspNetCore.Cookies");
        if (aspNetCookie !== undefined) {
            console.log("Cookie Exists");
        }
        else {
            navigate('/login');
        }
    };

    useEffect(() => {
        authCheck();
        console.log(dataSource)
    });

    const getFirstDay = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();
        return new Date(currentYear, currentMonth, 2);
    };

    const [dataSource, setdataSource] = useState([]);
    const [startDate, setStartDate] = useState(
        getFirstDay().toISOString().split('T')[0]
    );
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
    const [prodname, setprodname] = useState('');
    const [compname, setcompname] = useState('');
    const [firmname, setfirmname] = useState('');
    const [sitename, setsitename] = useState('');
    const [recogratestart, setrecogratestart] = useState(0);
    const [recograteend, setrecograteend] = useState(100);

    const products = ["유리Pro7S", "유리Pro7L", "유리Pro10", "유리Pro1", "도어Pro5"];

    const customItemCreating = (args) => {
        if (!args.text) {
            args.customItem = null;
            return;
          }
        args.customItem = args.text;
        setprodname(args.text);
        }
    
    const handleSearch = async () => {
        console.log("Button Pressed.")
        const data = createStore({
            loadUrl: `${config.apiUrl}/adminpage/masterpage?regdatestart=${startDate}&regdateend=${endDate}&prodname=${prodname}&firmname=${firmname}&compname=${compname}&sitename=${sitename}&recogratestart=${recogratestart}&recograteend=${recograteend}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.xhrFields = { withCredentials: true };
            },
        });
        setdataSource(data);
        console.log(data);
        console.log(data.loadUrl);
    }

    const handleKeyDown = (e) => {
        if (e.event.keyCode === 13) {
            handleSearch();
        }
    }

    const logout = async () => {
        await fetch(`${config.apiUrl}/auth/logout`, {
            method: 'GET',
            credentials: "include",
        })
            .then((res) => {
                if (res.ok) {
                    navigate('/login');
                }
            })
    }

    const Inline = {
        display: 'inline-block',
    };

    // const translateColumnName = (key) => {
    //     switch (key) {
    //         case 'jobNo':
    //             return 'JOB#';
    //         case 'regDate':
    //             return '해석등록일';
    //         case 'compName':
    //             return '고객명';
    //         case 'prodName':
    //             return '제품명';
    //         case 'firmName':
    //             return '거래처명';
    //         case 'siteName':
    //             return '현장명';
    //         case 'recogRate':
    //             return '인식률';
    //         case 'enterer':
    //             return '변환요청자';
    //         case 'enterDay':
    //             return '변환요청일시';
    //         case 'enterIP':
    //             return '변환요청IP';
    //         default:
    //             return '';
    //     }
    // };

    /*const renderImageLink = (data) => {
        return (
            <a href={data.recogimagefullpath} target="_blank" rel="noopener noreferrer">
                {data.recograte}
            </a>
        );
    };*/


    return (
        <><div id="box" style={{ height: '98vh', width: '98.8vw', padding: '10px' }}>
            <Box direction="col" width="100%" height="100%">
                <Item ratio={2}>
                    <Box
                        direction="col"
                        width="100%"
                        height="100%"
                        >
                        <Item ratio={0.2}>
                            
                            <Box
                                direction="row"
                                width="100%"
                                height="100%">
                                <Item ratio={1}>
                                    <div>
                                        <p style={{ fontSize: '16px', color: '#3cbab2', margin: '0px 2px 6px 38px', fontFamily: 'sans-serif' }}><b>AI 관리자페이지</b></p>
                                    </div>
                                </Item>
                                <Item ratio={5}>
                                    <div>
                                    </div>
                                </Item>
                                <Item ratio={0.3}>
                                    <Button
                                        width={120}
                                        text="로그아웃"
                                        type="default"
                                        stylingMode="contained"
                                        onClick={logout}
                                    />
                                </Item>
                            </Box>
                        </Item>
                        <Item
                            ratio={0.3}
                            baseSize={0}>
                            <Box
                                direction="row" 
                                width="100%"
                                height="100%">
                                <Item ratio={0.8}>
                                    <div className="dx-field" style={{Inline}}>
                                        <div className="dx-field-label">해석등록일자</div>
                                        <div className="dx-field-value">
                                            <DateBox value={startDate}
                                                onValueChanged={(e) => setStartDate(e.value)}
                                                displayFormat="yy.MM.dd"
                                                type="date" />
                                        </div>
                                    </div>
                                </Item>
                                <Item ratio={0.03}>
                                    <div>
                                        <span style={{width:"3px"}}>~</span>
                                    </div>
                                </Item>
                                <Item ratio={0.5}>
                                    <div className="dx-field" style={Inline}>
                                            <DateBox value={endDate}
                                                onValueChanged={(e) => setEndDate(e.value)}
                                                displayFormat="yy.MM.dd"
                                                type="date" /> 
                                    </div>
                                </Item>
                                <Item ratio={0.8}>
                                    <div className="dx-field">
                                        <div className="dx-field-label">제품명</div>
                                        <div className="dx-field-value">
                                            <SelectBox value={prodname}
                                                placeholder=""
                                                items={products}
                                                acceptCustomValue={true}
                                                onCustomItemCreating={customItemCreating}
                                                onKeyDown={handleKeyDown}
                                                onValueChanged={(e) => setprodname(e.value || '')} />
                                        </div>
                                    </div>
                                </Item>
                                <Item ratio={0.8}>
                                    <div className="dx-field">
                                        <div className="dx-field-label">고객명</div>
                                        <div className="dx-field-value">
                                            <TextBox value={compname}
                                                onKeyDown={handleKeyDown}
                                                onValueChanged={(e) => setcompname(e.value)} />
                                        </div>
                                    </div>
                                </Item>
                                <Item ratio={0.2}>
                                    <div>
                                    </div>
                                </Item>
                                <Item ratio={0.4}>
                                <div className="dx-field" style={Inline}>
                                        <div className="dx-field-label">인식률</div>
                                        <div className="dx-field-value" >
                                            <NumberBox step={10}
                                                min={0}
                                                max={100 }
                                                onValueChanged={(e) => setrecogratestart(e.value)}
                                                showSpinButtons={true} />
                                        </div>
                                    </div>
                                </Item>
                                <Item ratio={0.03}>
                                    <div>
                                        <span style={{width:"3px"}}>~</span>
                                    </div>
                                </Item>
                                <Item ratio={0.4}>
                                <div className="dx-field" style={Inline}>
                                        <div className="dx-field-value" style={{float:'left'}}>
                                            <NumberBox step={10}
                                                defaultValue={100}
                                                min={0}
                                                max={100}
                                                onValueChanged={(e) => setrecograteend(e.value)}
                                                showSpinButtons={true} />
                                        </div>
                                    </div>
                                </Item>
                                <Item ratio={1.4}>
                                    <div>
                                    </div>
                                </Item>
                            </Box>
                        </Item>
                        <Item
                            ratio={0.3}
                            baseSize={0}>
                            <Box
                                direction="row" 
                                width="100%"
                                height="100%">
                                <Item ratio={1.33}>
                                    <div className="dx-field" style={{Inline}}>
                                    </div>
                                </Item>
                                <Item ratio={0.8}>
                                    <div className="dx-field">
                                        <div className="dx-field-label">거래처명</div>
                                        <div className="dx-field-value">
                                            <TextBox value={firmname}
                                                onKeyDown={handleKeyDown}
                                                onValueChanged={(e) => setfirmname(e.value)} />
                                        </div>
                                    </div>
                                </Item>
                                <Item ratio={0.8}>
                                    <div className="dx-field">
                                        <div className="dx-field-label">현장명</div>
                                        <div className="dx-field-value">
                                            <TextBox value={sitename}
                                                onKeyDown={handleKeyDown}
                                                onValueChanged={(e) => setsitename(e.value)} />
                                        </div>
                                    </div>
                                </Item>
                                <Item ratio={2.43}>
                                    <div className="dx-field" style={Inline}>
                                    </div>
                                </Item>
                            </Box>
                        </Item>
                    </Box>
                </Item>
                <Item ratio={9}>
                    <div style={{ padding: '10px', borderTop: '1px solid #3cbab2' }}>
                        <RecogResultDatagrid dataSource={dataSource} handleSearch={handleSearch} />
                    </div>
                </Item>
                <Item ratio={1}>
                    <div className="footer">
                    </div>
                </Item>
            </Box>
        </div></>


    );
};